import Vue from 'vue';
import App from './App.vue';
import router from "./router";
import store from "./store";
import Loading from "components/lib/Loading.vue";
import Breadcrumbs from "components/lib/Breadcrumbs.vue";
import Login from "components/Login.vue";
import moment from 'vue-moment';
import i18n from './locale/multilanguage';
import Toats from 'components/lib/Toats.vue';
import VueSignaturePad from 'vue-signature-pad';
import VueNumberInput from '@chenfengyuan/vue-number-input';
import VueOnlinePlugin from 'vue-navigator-online';
import './assets/custom.scss';
import './registerServiceWorker';

import {
    BootstrapVue,

    BIcon,
    BIconGeoAlt,
    BIconBook,
    BIconFilePlus,
    BIconCheckCircle,
    BIconInbox,
    BIconInboxFill,
    BIconTruck,
    BIconListTask,
    BIconXCircle,
    BIconCheck2All,
    BIconBoxArrowDownRight,
    BIconCaretDownFill,
    BIconArrowRepeat
} from 'bootstrap-vue'

Vue.component("b-icon", BIcon);
Vue.component("b-icon-geo-alt", BIconGeoAlt);
Vue.component("b-icon-arrow-repeat", BIconArrowRepeat);
Vue.component("b-icon-file-plus", BIconFilePlus);
Vue.component("b-icon-book", BIconBook);
Vue.component("b-icon-check-circle", BIconCheckCircle);
Vue.component("b-icon-inbox", BIconInbox);
Vue.component("b-icon-inbox-fill", BIconInboxFill);
Vue.component("b-icon-truck", BIconTruck);
Vue.component("b-icon-list-task", BIconListTask);
Vue.component("b-icon-x-circle", BIconXCircle);
Vue.component("b-icon-check2-all", BIconCheck2All);
Vue.component("b-icon-box-arrow-down-right", BIconBoxArrowDownRight);
Vue.component("b-icon-box-caret-down-fill", BIconCaretDownFill);


Vue.config.productionTip = true;
//Vue.config.silent = true; // for dev
//Vue.config.devtools = true; //for dev

Vue.use(BootstrapVue)

Vue.component("Loading", Loading);
Vue.component("Login", Login);

Vue.component("Breadcrumbs", Breadcrumbs);
Vue.component("Toats", Toats);
Vue.component("vue-number-input", VueNumberInput);

Vue.use(moment);
Vue.use(VueSignaturePad);
Vue.use(VueOnlinePlugin);



new Vue({
    el: "#app",
    router,
    store,
    i18n,
    template: "<App/>",
    components: { App }
})
